
import {Component, OnInit, OnDestroy, ViewChild, Inject} from '@angular/core';
import {TranslateService} from 'ng2-translate';
import {AuthService} from './auth/auth.service';
import {environment} from '../environments/environment';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {GlobalService} from './global/global.service';
import {Title} from '@angular/platform-browser';
import {WindowRef} from "./core/window.service";
import { DOCUMENT } from '@angular/platform-browser';

import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {Subscription} from "rxjs/Subscription";
import {UtilService} from "./auth/util.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  version = 0;
  build = 1;
  globalSub: Subscription;
  routeChangeSub: Subscription;
  isSite: boolean;
  siteUrls = ['', 'platform', 'pricing', 'use-cases']
  @ViewChild('terms') terms;
  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private global: GlobalService,
    private  titleService: Title,
    private window: WindowRef,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.addListenerForInternetConnectivity();
    this.routeChangeSub = this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      })
      .filter((route) => {
        console.log(route.snapshot['_routerState'].url.split('/')[1]);
        if ( this.siteUrls.indexOf(route.snapshot['_routerState'].url.split('/')[1]) > -1) {this.isSite = true; }
        return route.outlet === 'primary';
      })
      .mergeMap((route) => route.data)
      .subscribe((event) => {
        this.titleService.setTitle(event['title']); this.document.body.scrollTop = 0; });
  }

  ngOnInit() {
    this.setTranslationProperties();
    this.setAuthUrl();
    this.setLogoutUrl();
   this.global.getPopupSubject();
   this.globalSub = this.global.getPopupSubject()
     .subscribe( (nextState) => {
        if (nextState) {
          this.terms.open();
          return;
        }
        this.terms.close();
     });

  }
  setTranslationProperties() {
    this.translate.setDefaultLang('en');
    let browserLang: string = this.translate.getBrowserLang();
    this.translate.addLangs(['en', 'fr']);
    this.translate.use(browserLang.match(/en/) ? browserLang : 'en');
  }

  setAuthUrl() {
    this.authService.setAuthUrl({site: environment.auth.site,
      clientId: environment.auth.clientId,
      authPath: environment.auth.authPath,
      redirectUri: environment.auth.redirectUri,
      scope: environment.auth.scope
  });
  }
  setLogoutUrl() {
    this.authService.setLogoutUrl(environment.auth.site,
      environment.auth.endSession,
      environment.auth.logoutUri
    );
  }
  addListenerForInternetConnectivity() {
    this.window.nativeWindow.addEventListener('online',  status => this.utilService.setOnline());
    this.window.nativeWindow.addEventListener('offline', status => this.utilService.setOffline());
  }


  removeInternetConnectivityListener() {
    this.window.nativeWindow.removeEventListener('online');
    this.window.nativeWindow.removeEventListener('offline');
  }

  ngOnDestroy() {
    this.removeInternetConnectivityListener();
    this.globalSub.unsubscribe();
    this.routeChangeSub.unsubscribe();
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts